import { ActivationDocumentTypes, AllDocumentTypes, documentTitles } from 'types';

import FormSection from '../Forms/FormSection';
import { IncentivesDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';

import { DocumentList } from './Documents/DocumentList';

type IncentivesProps = {
  originContext?: string;
  allowArchive?: boolean;
  showCheckboxes?: boolean;
  checkboxCategories?: AllDocumentTypes[];
  isPackageEditable?: boolean;
};

export const Incentives = ({
  originContext,
  allowArchive,
  showCheckboxes = false,
  checkboxCategories = [],
  isPackageEditable = true,
}: IncentivesProps) => {
  return (
    <FormSection description={IncentivesDescription()} title="Incentive Documents">
      <DocumentList
        documentTypeFilter={[ActivationDocumentTypes.incentives]}
        title="Incentive Document"
        showTypeLabelOnItems={false}
        baseCategory={documentTitles.incentiveDocuments}
        uploadContext={originContext}
        allowArchive={allowArchive}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
